import React, { cloneElement, FC } from 'react';
import { useTooltip, TooltipPopup, Position } from '@reach/tooltip';
import Portal from '@reach/portal';
import styled from '@emotion/styled';

import useStylesheets from '@vromo/hooks/useStylesheets';

type Props = {
    label: string;
    ariaLabel?: string;
    position?: 'bottom' | 'right';
};

type Rect = {
    left: number;
    right: number;
    width: number;
    height: number;
    top: number;
    bottom: number;
};

import ToolTipStyles from '@reach/tooltip/styles.css';



// todo: Warning: Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?
// todo: Check the render method of `Tooltip`.

const Tooltip: FC<Props> = ({ children, label, ariaLabel, position = 'bottom' }) => {

    useStylesheets(ToolTipStyles);

    const [trigger, tooltip] = useTooltip();
    const { isVisible, triggerRect } = tooltip;

    const arrowType = {
        bottom: styled.div`
            position: absolute;
            left: ${triggerRect && triggerRect.left - 10 + triggerRect.width / 2}px;
            top: ${triggerRect && triggerRect.bottom + window.scrollY}px;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid black;
        `,
        right: styled.div`
            position: absolute;
            left: ${triggerRect && triggerRect.right + 5}px;
            top: ${triggerRect && triggerRect.top - 6 + triggerRect.height / 2 + window.scrollY}px;
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-right: 8px solid black;
            border-bottom: 8px solid transparent;
        `
    };

    const positionFunc: {[key: string]: Partial<Position>} = {
        bottom: (triggerRect: Rect, tooltipRect: Rect) => {
            const triggerCenter = triggerRect.left + triggerRect.width / 2;
            const left = triggerCenter - tooltipRect.width / 2;
            const maxLeft = window.innerWidth - tooltipRect.width - 2;

            return {
                left: Math.min(Math.max(2, left), maxLeft) + window.scrollX,
                top: triggerRect.bottom + 8 + window.scrollY
            };
        },
        right: (triggerRect: Rect) => {
            const triggerCenter = triggerRect.top + triggerRect.height / 2 - 10;
            return {
                left: triggerRect.right + 10 + window.scrollX,
                top: triggerCenter + window.scrollY
            };
        }
    };

    const Arrow = arrowType[position];

    return (
        <>
            {cloneElement(children, trigger)}
            {isVisible && (
                <Portal>
                    <Arrow style={{ zIndex: 40000 }} />
                </Portal>
            )}
            <TooltipPopup
                {...tooltip}
                label={label}
                ariaLabel={ariaLabel}
                style={{
                    background: 'black',
                    fontWeight: 500,
                    color: 'white',
                    border: 'none',
                    borderRadius: '3px',
                    padding: '0.5em 1em',
                    zIndex: 40000
                }}
                position={positionFunc[position] as Position}
            />
        </>
    );
}

export default Tooltip
